import meta from './surahMeta.json';
import type { SurahMeta } from './source';

/**
 * Surah names alone — 12 KB, generated from uthmani.json.
 *
 * It exists so a screen that needs only a NAME does not pull the whole 1.4 MB
 * Quran text in behind it. On the web that difference is the entire initial
 * bundle: the student's home page shows "آخر موضع: سُورَةُ الكَهۡفِ" and
 * nothing else from the text.
 *
 * surahMeta.test.ts compares this table against bundledQuran and fails if the
 * two ever disagree, so the copy cannot drift from its source.
 */
export const SURAH_META = meta as SurahMeta[];

export function surahMeta(n: number): SurahMeta | null {
  return SURAH_META[n - 1] ?? null;
}
